import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { dataSelectors } from "../../../ducks/data";
import { isNowInDateRange } from "../../../utils/date";

export const useMaintenance = () => {
  const navigation = useNavigate();
  const maintenance = useSelector(dataSelectors.maintenance);

  useEffect(() => {
    if (maintenance.start_date && maintenance.end_date) {
      if (
        !maintenance.is_maintenance ||
        !isNowInDateRange(maintenance.start_date, maintenance.end_date)
      ) {
        navigation(PageRoutes.LOGIN);
      }
    }
  }, [maintenance]);

  return {};
};
